import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/home/home')
    },
    {
      path: '/reward-guide',
      name: 'rewardGuide',
      component: () => import('@/views/reward-guide/reward-guide')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js